<template>
    <img-upload-resize
        :autoRotate="true"
        :className="['file-input']"
        :debug="0"
        :id="id"
        :maxHeight="imageMaxHeight"
        :maxWidth="imageMaxWidth"
        :preview="false"
        :quality="0.9"
        @input="setImage"
        @onUpload="startImageResize"
        accept="image/*"
        capture="user"
        doNotResize="[]"
        outputFormat="string"
    >
        <template v-slot:upload-label>
            <label :for="id">
                <v-avatar
                    :height="height"
                    :width="width"
                    max-width="100%"
                    class="mx-auto"
                    color="rgba(127,127,127,0.1)"
                    tile
                >
                    <v-btn
                        @click="clearImage"
                        absolute
                        class="mt-9"
                        color="secondary darken-2"
                        fab
                        right
                        small
                        top
                        v-show="image && !isProcessing"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-progress-circular
                        :size="50"
                        indeterminate
                        v-if="isProcessing"
                    ></v-progress-circular>
                    <v-img
                        :src="image"
                        cover
                        v-else-if="image"
                    ></v-img>
                    <div v-else>
                        <v-icon size="100px">mdi-account-outline</v-icon>
                        <br />Select Image
                    </div>
                </v-avatar>
            </label>
        </template>
    </img-upload-resize>
</template>

<script>
import imgUploadResize from "vue-image-upload-resize";
import uuid4 from "../helpers/uuid4";
export default {
    mounted: function() {
        this.fileInput = document.getElementById(this.id);
    },
    components: {
        imgUploadResize
    },
    props: ["imageIn", "width", "height", "imageMaxHeight", "imageMaxWidth"],
    data() {
        return {
            image: this.imageIn,
            id: uuid4(), //unique id is required for multiple upload elements
            fileInput: null,
            isProcessing: null
        };
    },
    methods: {
        setImage(newImage) {
            this.image = newImage;
            this.emitImage(newImage);
        },
        emitImage() {
            this.$emit("imageDone", this.image);
            this.isProcessing = false;
        },
        startImageResize() {
            this.$emit("imageProcessing");
            this.isProcessing = true;
            this.image = null;
        },
        clearImage() {
            this.image = null;
            this.fileInput.value = null;
            this.emitImage(null);
        }
    }
};
</script>

<style lang="stylus" scoped>
label
    display: block
    text-align: center
    cursor: pointer

div >>> .file-input
    display: none
</style>